import React from 'react';
import { IPostCategory, IPostModel } from '../../models';
import { Link, NavLink, useParams } from 'react-router-dom';
import Avatar from '../avatar/avatar.component';
import Nametag from '../cosmetics/nametag.component';
import _ from 'lodash';
import { useCategories } from '../../hooks/use-categories/useCategories';
import dayjs from 'dayjs';
import { MdGroups, MdPublic, MdAccountCircle } from 'react-icons/md';
import { FaUserAlt } from 'react-icons/fa';

import { useSelector } from 'react-redux';
import { RootState } from '../../configuration';
import { buildProfileSlug } from '../../utils/profileSlug';

const PostHeader = ({
  post,
  currentCategory,
  profileUser,
}: {
  post?: IPostModel;
  currentCategory?: IPostCategory;
  profileUser?: boolean;
}) => {
  // Enum AudienceType của post-service: 0 Public, 1 Private (chỉ mình tôi), 2 Friends (bạn bè).
  const isPublic = post?.sharedPostAudienceType === 0;
  const isFriend = post?.sharedPostAudienceType === 2;
  const isOnlyMe = post?.sharedPostAudienceType === 1;
  const userProfile = useSelector(
    (state: RootState) => state.features.auth.profile
  );

  const isMe = userProfile?.userId === post?.userId;

  return (
    <>
      <Link
        className=" cursor-pointer"
        to={isMe ? '/profile' : `/user/${buildProfileSlug(post?.userFullName, post?.userSequenceId, post?.username)}`}
      >
        <Avatar
          avatar={_.get(post, 'userAvatar', '')}
          label={_.get(post, 'userFullName', '')}
          size="sm"
          userId={post?.userId}
        />
      </Link>
      <div className="w-full">
        <div>
          <Nametag userId={post?.userId} banner compact className="mb-1">
            <Link
              className="inline-block text-slate-800 dark:text-slate-50 text-base font-bold"
              to={isMe ? '/profile' : `/user/${buildProfileSlug(post?.userFullName, post?.userSequenceId, post?.username)}`}
            >
              {post?.userFullName ?? 'Người dùng không xác định'}
            </Link>
          </Nametag>
          {post?.postType === 'share' && (
            <span className="font-light ml-1">đã chia sẻ 1 bài viết</span>
          )}
          <div className="flex items-center space-x-2 text-sm leading-4">
            <NavLink
              to={`/category/${post?.categoryId}`}
              className={({ isActive, isPending }) =>
                isActive ? 'pointer-events-none' : ''
              }
            >
              <span className="text-branding font-semibold">
                {_.get(currentCategory, 'name', '')}
              </span>
            </NavLink>
            <span>•</span>
            <span>{dayjs.utc(post?.createdAt).fromNow()}</span>
            {post?.postType === 'share' && (
              <span className="ml-1">
                {isPublic && <MdPublic size={16} />}{' '}
                {isFriend && <MdGroups size={20} />} {isOnlyMe && <FaUserAlt />}
              </span>
            )}
          </div>
          {post?.isSponsored && (
            <div className="text-xs font-medium text-amber-600 dark:text-amber-400">
              Được tài trợ bởi {post.sponsorName}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default PostHeader;
